import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { useEditIMetadataTagZonesStore } from "./editIMetadataTagZonesStore/editIMetadataTagZonesStore";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export const InstructionsDialog = () => {
  const { instructionsDialogOpen, setInstructionsDialogOpen } =
    useEditIMetadataTagZonesStore();

  return (
    <Dialog
      open={instructionsDialogOpen}
      onClose={() => setInstructionsDialogOpen(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Metadata Tag Zone Drawing Instructions</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setInstructionsDialogOpen(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <div className="pb-[20px]">
          <p className="font-normal text-[17px] ">
            To begin creating a shape click anywhere on the image to start
            adding points.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To finish creating a shape, click on the first point created.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To modify the shape click and drag the points to the desired
            location.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To add additional points to the shape, click on the line between two
            points.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To create an additional shape, click anywhere on the image to start
            adding points.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To delete a shape hover anywhere over the shape and click to select.
            Then press the delete key on your keyboard.
          </p>
          <br></br>
          <p className="font-normal text-[17px]">
            To delete a single point double click on the point. This action will
            only work if the remaining shape will have at least 3 points.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
